// const os = require("os");
// function getLocalIPAddress() {
//   const interfaces = os.networkInterfaces();
//   for (const key in interfaces) {
//     for (const iface of interfaces[key]) {
//       if (iface.family === "IPv4" && !iface.internal) {
//         return iface.address;
//       }
//     }
//   }
// }
// console.log(getLocalIPAddress());
import XLSX from "xlsx";
import { saveAs } from "file-saver";
export function saveExcel(data, fileName) {
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(data);

    // 设置第一列的宽度为15
    const columnWidths = [];
    console.log(data[0])
    for (let v in data[0]) {
        columnWidths.push({ wch: v.length * 2.5 })
    }
    worksheet['!cols'] = columnWidths;

    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
    });
    const excelData = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    saveAs(excelData, fileName + ".xlsx");
}

//读取表格文件
export function handleFileUpload(event) {
    return new Promise((resolve, reject) => {
        const file = event.target.files[0];
        const reader = new FileReader();
        const a = setTimeout(() => {
            this.$message.warning("读取超时，请稍候再试");
            reject();
        }, 10 * 1000);
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array" });
            const worksheet = workbook.Sheets[workbook.SheetNames[0]];
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
            clearTimeout(a);
            resolve(jsonData);
        };
        reader.readAsArrayBuffer(file);
    });
}



/**
 * 以obj.height 为基准 压缩
 * baseImage base64 图片
 * obj { width: 900, height: 35 }
 * quality 图像质量  0 - 1   1 质量越高
 */
export function imageCompression(baseImage, obj, quality, callback) {
    var img = new Image();
    img.src = baseImage;
    img.onload = function () {
        var that = this;
        var w = that.width, h = that.height;
        //按照h 压缩后的base64 和 width
        var compressionResult, compressionWidth, compressionHeight;
        if (h > obj.height) {
            //生成canvas
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d');
            //创建属性节点
            var createw = document.createAttribute('width');
            var createh = document.createAttribute('height');
            h = obj.height;
            w = (h / that.height) * w;
            compressionWidth = w;
            compressionHeight = h;
            createw.nodeValue = w;
            createh.nodeValue = h;
            canvas.setAttributeNode(createw);
            canvas.setAttributeNode(createh);
            ctx.drawImage(that, 0, 0, w, h);
            var base64 = canvas.toDataURL('image/png', quality);
            compressionResult = base64;
        } else {
            compressionResult = baseImage;
            compressionWidth = that.width;
            compressionHeight = that.height;
        }
        //width > 默认width  做截取处理
        if (compressionWidth > obj.width) {
            ClippingImage(compressionResult, obj.width, compressionHeight, quality, function (base64Clipping) {
                callback(base64Clipping);
            });
        } else {
            callback(compressionResult);
        }

    }
}

/**
 * 图片截取
 * base64Codes  图片base64 码
 * 从 (0,0) 开始截取   宽高分别为 width，height
 * quality  图片质量  0 - 1 ，  1 图片质量最高
 * callback  返回的是 截取后的base64 字符串
 */
export function ClippingImage(base64Codes, width, height, quality, callback) {
    let img = new Image();
    img.src = base64Codes;
    //生成canvas
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    var createw = document.createAttribute('width');
    var createh = document.createAttribute('height');
    createw.nodeValue = width;
    createh.nodeValue = height;
    canvas.setAttributeNode(createh);
    canvas.setAttributeNode(createw);
    img.onload = function () {
        ctx.drawImage(img, 0, 0, width, height, 0, 0, width, height);
        var base64Result = canvas.toDataURL('image/png', quality);
        callback(base64Result)
    }
}

/**
 * base64转file
 * @param {*} dataurl 
 * @param {*} name 
 * @returns 
 */
export function dataURLtoBlob(base64Data, fileName = '文件名称') {
    const base64 = base64Data.split(';base64,').pop();
    const byteCharacters = atob(base64);
    const byteArrays = [];

    for (let i = 0; i < byteCharacters.length; i++) {
        byteArrays.push(byteCharacters.charCodeAt(i));
    }

    const byteArray = new Uint8Array(byteArrays);
    const blob = new Blob([byteArray], { type: 'image/png' });

    return new File([blob], fileName, { type: 'image/png' });
}